import { getRouteParams } from './router';
import { savedAddressesIdsSelector } from '../domainData/selectors';
import { createSelector } from 'reselect';


export const isAddressPageAddressSavedSelector = createSelector([
  getRouteParams,
  savedAddressesIdsSelector,
], ({ address }, savedIds) => savedIds.has(address));
